document.addEventListener('DOMContentLoaded', () => {

    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smooth: true,
        wheelMultiplier: 1
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    gsap.to('.discover-luxury-title', {
        opacity: 1,
        translateY: 0,
        duration: 1.0,
        ease: 'power3.out',
        delay: 0.1
    });

    let swiperInstances = [];
    const initSwiperCarousels = () => {
        swiperInstances.forEach(instance => { if(instance.destroy) instance.destroy(true, true); });
        swiperInstances = [];

        const containers = document.querySelectorAll('.luxury-swiper-container');
        containers.forEach(container => {
            const parentPane = container.closest('.pane-luxury-content');
            if (parentPane && !parentPane.classList.contains('active')) return;

            const instance = new Swiper(container, {
                slidesPerView: 2,
                spaceBetween: 16,
                grabCursor: true,
                speed: 800, // Smooth transition pace
                cssMode: false,
                touchRatio: 1.5,
                freeMode: {
                    enabled: true,
                    sticky: true,
                    momentumRatio: 0.5
                },
                watchSlidesProgress: true,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: container.querySelector('.swiper-button-next'),
                    prevEl: container.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    768: { slidesPerView: 3, spaceBetween: 24 },
                    1024: { slidesPerView: 4, spaceBetween: 30 }
                }
            });
            swiperInstances.push(instance);
        });
    };

    initSwiperCarousels();

    const tabs = document.querySelectorAll('.tab-luxury-btn');
    const panes = document.querySelectorAll('.pane-luxury-content');

    tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            
            if(tab.classList.contains('active')) return;
            
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            const targetId = tab.getAttribute('data-target');
            const targetPane = document.getElementById(targetId);

            panes.forEach(pane => {
                if(pane.classList.contains('active')) {
                    pane.classList.remove('active');
                    
                    gsap.to(pane, {
                        opacity: 0,
                        duration: 0.15,
                        onComplete: () => {
                            pane.style.display = 'none';
                            
                            if(targetPane) {
                                targetPane.style.display = 'block';
                                targetPane.classList.add('active');
                                
                                initSwiperCarousels();
                                
                                gsap.fromTo(targetPane, 
                                    { opacity: 0 }, 
                                    { 
                                        opacity: 1, 
                                        duration: 0.2,
                                        onComplete: () => {
                                            ScrollTrigger.refresh();
                                            lenis.resize();
                                        }
                                    }
                                );
                            }
                        }
                    });
                }
            });
        });
    });

    const actionCartBtns = document.querySelectorAll('.luxury-desktop-add-cart-btn, .luxury-mobile-add-cart-btn');
    const luxuryOverlay = document.getElementById('luxuryOverlay');
    const luxuryDrawer = document.getElementById('luxuryDrawer');
    const luxuryClose = document.getElementById('luxuryCloseDrawer');
    const luxuryTitle = document.getElementById('luxuryDrawerTitle');

    actionCartBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const variantId = btn.getAttribute('data-variant-id');
            const card = btn.closest('.product-luxury-card');
            const productTitle = card.querySelector('.luxury-product-title').innerText;

            if (!variantId) return;

            let itemPayload = { 'items': [{ 'id': parseInt(variantId), 'quantity': 1 }] };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(itemPayload)
            })
            .then(response => response.json())
            .then(() => {
                luxuryTitle.innerText = productTitle;
                luxuryOverlay.classList.add('open');
                luxuryDrawer.classList.add('open');
                document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            })
            .catch((err) => console.error('AJAX Processing Error:', err));
        });
    });

    const closeLuxuryDrawer = () => {
        luxuryOverlay.classList.remove('open');
        luxuryDrawer.classList.remove('open');
    };

    if (luxuryClose) luxuryClose.addEventListener('click', closeLuxuryDrawer);
    if (luxuryOverlay) luxuryOverlay.addEventListener('click', closeLuxuryDrawer);
    
    window.addEventListener('resize', () => {
        ScrollTrigger.refresh();
        lenis.resize();
    });
});